import {
  put, takeEvery,
} from 'redux-saga/effects';
import {
  ACT_DYNASTIES_FETCH_INIT,
} from '../constants/actions';
import {
  dynastiesFetchSuccessAction,
} from '../actions';
import Api from '../services/Api';

function* fetchDynasties() {
  const { status, data } = yield Api.get('types/dynasties?per_page=500', false);
  if (status === 200) {
    yield put(dynastiesFetchSuccessAction(data.data));
  }
}

function* dynastiesSagas() {
  yield takeEvery(ACT_DYNASTIES_FETCH_INIT, fetchDynasties);
}

export default dynastiesSagas;
